module.exports = __webpack_public_path__ + "img/icon-desktop.b2b99ddc.svg";